module.exports = __webpack_public_path__ + "img/doctor_nuevo.e9691b79.svg";